<template>
  <v-layout
    v-if="whitelabelStats" 
    class="overview-card"
    wrap
  >
    <v-flex
      md12
      xs12
    >
      <v-card>
        <v-layout
          wrap
        >
          <v-flex
            md4
            xs12
          >
            <span>{{ $t('traderdashboard.revenue') }}</span>
            <p
              class="text-primary mt-2"
              style="font-size:26px;"
            >
              {{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.total }}
            </p>
          </v-flex>
          <v-flex
            md4
            xs12
          >
            <span>{{ $t('traderdashboard.revenueSubscription') }}</span>
            <p
              class="mt-2"
            >
              {{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.total }}
            </p>
          </v-flex>
          <v-flex
            md4
            xs12
          >
            <span>{{ $t('traderdashboard.revenueTrading') }}</span>
            <p
              class="mt-2"
            >
              {{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_trading.total }}
            </p>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex
      md6
      xs12
    >
      <v-card>
        <span>{{ $t('traderdashboard.users') }}</span>
        <p>
          {{ whitelabelStats.users.total }}
        </p>
      </v-card>
    </v-flex>
    <v-flex
      md6
      xs12
    >
      <v-card>
        <span>{{ $t('traderdashboard.copyAccounts') }}</span>
        <p>
          {{ whitelabelStats.connections.active }}
          <small style="font-weight:300;font-size:12px;">
            ({{ whitelabelStats.connections.paused }} {{ $t('traderdashboard.paused') }}, 
            {{ whitelabelStats.connections.unlinked }} {{ $t('traderdashboard.unlinked') }})
          </small>
        </p>
      </v-card>
    </v-flex>
    <v-flex
      md6
      xs12
    >
      <v-card>
        <span>{{ $t('traderdashboard.pnlThisMonth') }}</span>
        <p
          v-for="(d, i) in whitelabelStats.trading_result.this_month"
          :key="i"
        >
          {{ d.currency | renderSymbol }} {{ d.amount }}<br>
        </p>
      </v-card>
    </v-flex>
    <v-flex
      md6
      xs12
    >
      <v-card>
        <span>{{ $t('traderdashboard.pnlTotal') }}</span>
        <p
          v-for="(d, i) in whitelabelStats.trading_result.total"
          :key="i"
        >
          {{ d.currency | renderSymbol }} {{ d.amount }}<br>
        </p>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
const TRADER_OVERVIEW_QUERY = require('@/graphql/queries/TraderOverview.gql');

export default {
  name: 'TraderOverview',
  props: {
    whitelabelStats: {
      type: Object,
      default: null
    },
  },
 
  data: () => ({
    tooltip: null,
    loading: false,
  }),
}
</script>



<style lang="scss" >
  .overview-card {
    .balance {
      font-weight: 700;
      font-size: 19px;
    }
    .v-btn__content {
      color: #fff;
      font-size: 15px;
    }
    span {
      font-size: 11px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      padding-top: 5px;
      font-size: 18px;
      font-weight: 700;
    }
  }
</style>
